/**
 * Zentrale Navigations-Icons (lucide-react).
 *
 * Warum hier und nicht in den Apps: nur `packages/ui` haengt von `lucide-react` ab.
 * Die Module importieren die Icons daher ueber `@pilot-hub/ui` und bleiben
 * unabhaengig von der Icon-Bibliothek. Ersetzt die frueheren Emoji-Icons.
 */
import {
  LayoutDashboard,
  Users,
  ScrollText,
  Car,
  Plane,
  Navigation,
  BatteryCharging,
  Siren,
  Download,
  Settings,
  Boxes,
  BookOpen,
  Radio,
  RadioTower,
  Map,
  ListChecks,
  Eye,
  ClipboardList,
  Video,
  ShieldAlert,
  Images,
  Route,
} from 'lucide-react'

/** Standardgroesse fuer Navigations-Icons (passt in die 32px-Kachel). */
export const NAV_ICON_CLASS = 'h-[18px] w-[18px]'

export const NavIcons = {
  dashboard: LayoutDashboard,
  users: Users,
  licenses: ScrollText,
  vehicles: Car,
  drones: Plane,
  akkus: BatteryCharging,
  missions: Siren,
  flights: Navigation,
  export: Download,
  settings: Settings,
  resources: Boxes,
  flightNew: Navigation,
  logbook: BookOpen,
  telemetry: Radio,
  map: Map,
  checklist: ListChecks,
  observe: Eye,
  missionDetails: ClipboardList,
  streams: Video,
  comms: RadioTower,
  risk: ShieldAlert,
  media: Images,
  route: Route,
} as const

export type NavIconName = keyof typeof NavIcons
